<template>
<div class="dashboard">
	<component v-if="view" v-bind:is="component"></component>
</div>
</template>

<script>



 export default {
	name: 'Dashboard',
	components: {
		"Client": () => import('../views/Client'),	
		"PanelMember": () => import('../views/PanelMember'),	
		"Admin": () => import('../views/Admin'),	
		"Welcome": () => import('../views/Welcome'),	
	},
	computed: {
		view: function(){
			return this.$store.state.auth.view;
		},
		component: function(){
			if( this.view == 'client'){
				return "Client"
			}
			if( this.view == 'panelmember'){
				return "PanelMember"
			}
			if( this.view == 'admin'){
				return "Admin"
			}
			if( this.view == 'visitor'){
				return "Welcome"
			}
			return "Login"
		}
	},

}
</script>
